// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileCategoriesNav_wrapper__p1dDI","link":"MobileCategoriesNav_link__nOA1S"};